




































































































































import { Icon } from '@alpha/ink'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { isEmpty } from 'lodash-es'
import store from '@/store'
import $ from 'jquery'
import insghtsSVG from '@/assets/img/insights-explore-data.svg'
import analytics from '@/analytics'

@Component({
  components: {
    Icon
  }
})
export default class SliceActionsSharedReports extends Vue {
  @Prop({ required: true }) insight!: any
  @Prop({ default: false }) loading!: boolean
  @Prop({ default: false }) isSharedReport!: boolean

  selectedChartName:string = ''
  selectedChart:any = false
  keyMap:any = {
    AGE: 'Age',
    STANDARD_HHI_US: 'HHI',
    GENDER: 'Gender',
    MS_is_mobile: 'Device Used',
    STANDARD_EMPLOYMENT: 'Employment',
    STANDARD_EDUCATION: 'Education',
    STANDARD_INDUSTRY_PERSONAL: 'Industry',
    STATE: 'State',
    QUESTIONS: 'Questions',
    TERM_FREQUENCY: 'Term Frequency',
    SENTIMENT_ANALYSIS: 'Sentiment Analysis',
    original: ''
  }

  hovering:boolean = false
  hoveredGroup:boolean | string = false
  insghtsSVG = insghtsSVG

  get isTextSlice ():boolean {
    return !!this.insight.textResponses
  }

  get hasSlices ():boolean {
    // hide slices menu if there's only a single slice
    return !isEmpty(this.slices) && Object.keys(this.slices).length > 1
  }

  get slices ():any {
    return this.insight.charts ? this.insight.charts : this.insight.textResponses
  }

  get selectedSliceName ():any {
    if (this.selectedChart === 'original') {
      return 'original'
    } else {
      var keys = Object.keys(this.slices)

      // keys are in a weird numbered format 'AGE_0' probably for indexing?
      var firstKey:any = keys[0].split('_')
      firstKey.pop()
      firstKey = firstKey.join('_')

      return firstKey
    }
  }

  get sliceStyle ():string {
    var slicesSeen:any = {}
    var chartKeys:any = Object.keys(this.slices)
    for (var i = 0; i < chartKeys.length; i++) {
      if (this.slices[chartKeys[i]].lucidKey === 'QUESTIONS') {
        continue
      }
      if (slicesSeen[this.slices[chartKeys[i]].lucidKey] && !['TERM_FREQUENCY', 'SENTIMENT_ANALYSIS'].includes(this.slices[chartKeys[i]].lucidKey)) {
        return 'filter'
      } else {
        slicesSeen[this.slices[chartKeys[i]].lucidKey] = 1
      }
    }
    return 'segment'
  }

  get chartsByDemographicWithNoInsight ():any {
    var demos:any = {}
    // var that = this
    if (this.sliceStyle === 'segment') {
      Object.keys(this.slices).forEach((chartId) => {
        const chart = this.slices[chartId]
        chart.originalChartId = chartId
        if (!['QUESTIONS', 'TERM_FREQUENCY', 'SENTIMENT_ANALYSIS'].includes(chart.lucidKey) && chart.type !== 'Question' && !chart.alphaAnalysis) {
          demos[chart.lucidKey || chartId] = chart
        }
      })
    } else {
      Object.keys(this.slices).forEach((chartId) => {
        var chart = this.slices[chartId]
        chart.originalChartId = chartId
        var key = chart.lucidKey || chartId
        demos[key] = demos[chart.lucidKey] || []
        demos[key].push(chart)
      })
    }
    return demos
  }

  get sortedChartsByDemographic ():any {
    // chartsByDemographic was an unsorted hash so we weren't getting consistent orders in dropdowns,
    // moved to a simple sorted array
    return Object.keys(this.chartsByDemographicWithNoInsight)
      .sort((a, b) => {
        const aChart = this.chartsByDemographicWithNoInsight[a]
        const bChart = this.chartsByDemographicWithNoInsight[b]

        if (a === 'original') return -1
        if (b === 'original') return 1

        let aIndex = this.determineChartIndex(aChart)
        aIndex = parseInt(aIndex, 10)

        let bIndex = this.determineChartIndex(bChart)
        bIndex = parseInt(bIndex, 10)
        if (aIndex > bIndex) return 1
        if (aIndex < bIndex) return -1
        return 0
      })
      .map(key => ({ sliceName: key, chart: this.chartsByDemographicWithNoInsight[key] }))
  }

  get sortedChartsByDemographicWithInsight ():any {
    return Object.keys(this.chartsWithInsights)
      .sort((a, b) => {
        const aChart = this.chartsWithInsights[a]
        const bChart = this.chartsWithInsights[b]

        if (a === 'original') return -1
        if (b === 'original') return 1

        let aIndex = this.determineChartIndex(aChart)
        aIndex = parseInt(aIndex, 10)

        let bIndex = this.determineChartIndex(bChart)
        bIndex = parseInt(bIndex, 10)
        if (aIndex > bIndex) return 1
        if (aIndex < bIndex) return -1
        return 0
      })
      .map(key => ({ sliceName: key, chart: this.chartsWithInsights[key] }))
  }

  get chartsByQuestions ():any {
    return this.groupChartsByType('QUESTION')
  }

  get chartsByTermFrequency ():any {
    return this.groupChartsByType('TERM_FREQUENCY')
  }

  get chartsBySentimentAnalysis ():any {
    return this.groupChartsByType('SENTIMENT_ANALYSIS')
  }

  get chartsWithInsights ():any {
    const { insight } = this
    const { charts, textResponses } = insight
    const slices = charts || textResponses
    if (!slices) {
      console.error('No chart views available for insight:', insight)
      return {}
    }
    const keys = Object.keys(slices)
    const availableInsights = keys.filter(key => {
      const value = slices[key]
      return value.alphaAnalysis
    }).reduce((acc:any, insightKey:any) => {
      const chart = slices[insightKey]
      const plainTextKey = chart.lucidKey || insightKey
      acc[plainTextKey] = chart
      return acc
    }, {})
    return availableInsights
  }

  get hasInsights ():any {
    return (this.insight.hasInsights || Object.keys(this.chartsWithInsights).length) && this.hasFeature('insightsFinder')
  }

  hasFeature (feature:any):any {
    return store.getters.feature.hasFeature(feature)
  }

  @Watch('insight', { immediate: true })
  insightChange () {
    if (this.slices.original) {
      this.selectedChartName = ''
      this.selectedChart = this.slices.original
    } else {
      // audience slices don't have an "original" chart, so set everything to that first chart
      var keys:any = Object.keys(this.slices)
      if (!keys.length) return
      // keys are in a weird numbered format 'AGE_0' probably for indexing?
      var firstKey:any = keys[0].split('_')
      firstKey.pop()
      firstKey = firstKey.join('_')

      this.selectedChartName = this.keyMap[firstKey]
      this.selectedChart = this.slices[firstKey]
    }
  }

  mounted () {
    var that = this
    // set slice name if necessary
    if (this.insight.asset_type === 'aud-slice') {
      var keys = Object.keys(this.chartsByDemographicWithNoInsight)
      this.selectSlice(this.chartsByDemographicWithNoInsight[keys[0]], keys[0])
    }

    $(document).on('keyup.sliceChart', function keyupSliceChart (e) {
      if (e.shiftKey) {
        switch (e.key) {
          case 'L':
            var sliceNames = Object.keys(that.slices)
            var selectedIndex = sliceNames.findIndex(function (sliceName) {
              return that.slices[sliceName] === that.selectedChart
            })
            var nextIndex = selectedIndex === sliceNames.length - 1 ? 0 : selectedIndex + 1
            var nextChart = that.slices[sliceNames[nextIndex]]
            that.selectSlice(nextChart, nextChart.lucidKey || sliceNames[nextIndex])
            break
          case 'K':
            sliceNames = Object.keys(that.slices)
            selectedIndex = sliceNames.findIndex(function (sliceName) {
              return that.slices[sliceName] === that.selectedChart
            })
            nextIndex = selectedIndex === 0 ? sliceNames.length - 1 : selectedIndex - 1
            nextChart = that.slices[sliceNames[nextIndex]]
            that.selectSlice(nextChart, nextChart.lucidKey || sliceNames[nextIndex])
            break
        }
      }
    })
  }

  beforeDestroy () {
    $(document).off('keyup.sliceChart')
  }

  normalizedTitle (originalTitle:string):string {
    if (originalTitle === 'Per Response View') {
      return 'Per response'
    } else if (originalTitle === 'Aggregate Chart View') {
      return 'Aggregate chart'
    } else if (originalTitle === 'Term Frequency Chart') {
      return 'Chart'
    } else if (originalTitle === 'Word Cloud') {
      return 'Word cloud'
    } else {
      return originalTitle
    }
  }

  // chart data structure can vary, so created a method to perform an initial check before getting index
  determineChartIndex (chartVersion:any) {
    if (chartVersion.originalChartId) {
      return chartVersion.originalChartId.split('_')[1]
    } else {
      if (chartVersion[0] && chartVersion[0].originalChartId) {
        return chartVersion[0].originalChartId.split('_')[1]
      } else {
        return this.getChartIndexByLucidKey(chartVersion.lucidKey)
      }
    }
  }

  getChartIndexByLucidKey (lucidKey:string):number {
    if (lucidKey === 'Age') {
      return 3
    } else if (lucidKey === 'HHI') {
      return 4
    } else if (lucidKey === 'Employment') {
      return 2
    } else if (lucidKey === 'Gender') {
      return 1
    }

    return -1
  }

  selectSlice (chart:any, sliceName:string) {
    this.selectedChart = chart
    if (sliceName === 'original') {
      this.selectedChartName = this.keyMap.original
    } else {
      if (this.sliceStyle === 'segment') {
        this.selectedChartName = this.keyMap[sliceName]
      } else {
        this.selectedChartName = this.keyMap[sliceName] + ' (' + chart.title + ')'
      }
    }

    // force bootstrap dropdown to always close after option is selected.
    $('[data-toggle="dropdown"]').parent().removeClass('open')

    // Analytics
    let eventTitle
    switch (chart.title) {
      case 'Per Response View':
        eventTitle = 'Sentiment Analysis: Per Response'
        break
      case 'Aggregate Chart View':
        eventTitle = 'Sentiment Analysis: Chart View'
        break
      default:
        break
    }
    if (eventTitle) {
      analytics.track(eventTitle)
    }
    // End Analytics

    // prepare object to update asset display/chart viewer
    var obj:any = { url: chart.url, slice: sliceName, alphaAnalysis: chart.alphaAnalysis }
    if (chart.asset_type) {
      obj = { url: chart.url, slice: sliceName, asset_type: chart.asset_type, lucidKey: chart.lucidKey, alphaAnalysis: chart.alphaAnalysis }
    }
    if (this.isSharedReport && this.isTextSlice && chart.asset_type !== 'viz-slice') {
      this.$emit('updateData', obj)
    }
    obj.title = chart.title
    this.$emit('updateURL', obj, sliceName)
  }

  isSelectedChart (chart:any):boolean {
    return chart === this.selectedChart
  }

  isSelectedSlice (slice:any):boolean {
    if (slice === 'original' && this.selectedChart.title === 'Main Output') {
      return true
    }
    return slice === this.selectedChart.lucidKey
  }

  isActiveFilterGroup (sliceName:any):boolean {
    return this.hovering ? (this.hoveredGroup === sliceName) : (this.selectedSliceName === sliceName)
  }

  hoverGroup (sliceName:string) {
    var that = this
    setTimeout(function () {
      that.hovering = true
      that.hoveredGroup = sliceName
    }, 50)
  }

  resetHover () {
    this.hovering = this.hoveredGroup = false
  }

  selectGroup (sliceName:string, $event:any) {
    var that = this
    if (sliceName === 'original') {
      this.selectSlice(this.slices.original, 'original')
    } else {
      $event.stopPropagation()
      setTimeout(function () {
        that.hovering = true
        that.hoveredGroup = sliceName
      }, 50)
    }
  }

  groupChartsByType (type:string) { // ['QUESTION', 'TERM_FREQUENCY', 'SENTIMENT_ANALYSIS']
    const ques:any = {}
    Object.keys(this.slices).forEach((chartId) => {
      const chart:any = this.slices[chartId]
      if (chart.lucidKey === type || (type === 'QUESTION' && chart.type === 'Questions')) {
        let key = chart.lucidKey || chartId
        if (type === 'QUESTION' && chart.type === 'Questions') {
          key = 'QUESTIONS'
        }
        ques[key] = ques[chart.lucidKey] || []
        ques[key].push(chart)
      }
    })
    return ques
  }
}
